import React from 'react'
import '../styles/home.css'
import { Container, Row, Col } from 'reactstrap';
import heroImg from '../assets/images/zebra-wild.jpg'
import heroImg02 from '../assets/images/giraffe-wild.jpg'
import heroVideo from '../assets/images/hero-video-4.MP4'
import worldImg from '../assets/images/world.png'
import experienceImg from '../assets/images/experience3.png'
import Subtitle from './../shared/Subtitle'
import ServiceList from '../services/ServiceList';
import FeaturedTourList from '../components/Featured-tours/FeaturedTourList';
import MasonryImagesGallery from '../components/Image-gallery/MasonryImagesGallery';
import Newsletter from '../shared/Newsletter';

const Home = () => {
  return (
    <>
      {/*=================Hero section================== */}
      <section>
        <Container>
          <Row>
            <Col lg='6'>
              <div className="hero__content">
                <div className="hero__subtitle d-flex items-align-center">
                  <Subtitle subtitle={"Know Before You Go"} />
                  <img src={worldImg} alt="" />
                </div>
                <h1>Discover Kenya's Wild Beauty with <span className="highlight">Coast Camping</span> Tours and Safaris</h1>
                <p> Embark on unforgettable adventures across Kenya’s stunning landscapes. From the golden savannas of the Masai Mara to the turquoise shores of Diani Beach, we offer expertly guided tours tailored just for you. Whether you're seeking thrilling wildlife safaris or serene coastal escapes, experience the magic of Kenya like never before.
                </p>
              </div>
            </Col>

            <Col lg='2'>
              <div className="hero__img-box">
                <img src={heroImg} alt="" />
              </div>
            </Col>

            <Col lg='2'>
              <div className="hero__img-box hero__video-box mt-4">
                <video src={heroVideo} alt="" controls />
              </div>
            </Col>

            <Col lg='2'>
              <div className="hero__img-box mt-5">
                <img src={heroImg02} alt="" />
              </div>
            </Col>


          </Row>
        </Container>
      </section>
      {/*=================Hero section ends================== */}

      <section>
        <Container>
          <Row>
            <Col lg='3'>
              <h5 className="services__subtitle">What we Serve</h5>
              <h2 className='services__title'>We offer our best services</h2>
            </Col>
            <ServiceList />
          </Row>
        </Container>
      </section>

      {/*=================Featured tour section starts================= */}
      <section>
        <Container>
          <Row>
            <Col lg='12' className='mb-5'>
              <Subtitle subtitle={'Explore'} />
              <h2 className="featured__tour-title">Our Featured tours</h2>


            </Col>
            <FeaturedTourList/>
          </Row>
        </Container>
      </section>
      {/*=================Featured tour section ends================== */}


      {/*=================Experience  section starts================== */}
      <section>
        <Container>
          <Row>
            <Col lg='6'>
            <div className="experience__content">
              <Subtitle subtitle={'Experience'} />
              <h2>Providing you with a lifetime experience</h2>
              <p>At Coast Camping Tours and Safaris, we’re passionate about showcasing the beauty and adventure that Kenya has to offer. With years of experience, we specialize in offering tailor-made safaris, beach excursions, and cultural tours across the country. Our goal is to provide unforgettable experiences, whether you’re exploring the savannas in search of wildlife or relaxing on the pristine beaches along the coast. <br /> <br />

We pride ourselves on delivering personalized services with expert tour guides, comfortable accommodations, and safe travel, ensuring your trip is seamless and unforgettable.</p>
            </div>
            <div className="counter__wrapper d-flex align-items-center gap-5">
              <div className="counter__box">
                <span>12k+</span>
                <h6>Successful trips</h6>
              </div>
              <div className="counter__box">
                <span>2k+</span>
                <h6>Regular Clients</h6>
              </div>
              <div className="counter__box">
                <span>15</span>
                <h6>Years experience</h6>
              </div>
            </div>
            </Col>
            <Col lg='6'>
            <div className="experience__img">
              <img src={experienceImg} alt="" />
            </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/*=================Experience section ends================== */}

      {/*=================Gallery section starts================== */}
      <section>
        <Container>
          <Row>
            <Col lg='12'>
            <Subtitle subtitle={'Gallery'} />
            <h2 className="gallery__title">Visit Our Customers tour gallery</h2>
            </Col>
            <Col lg='12'>
            <MasonryImagesGallery />
            </Col>
          </Row>
        </Container>
      </section>
      {/*=================Gallery section ends================== */}


      {/*================= TestImonials section starts ================== */}

{/* <section>
  <Container>
    <Row>
      <Col lg='12'>
      <Subtitle subtitle={'Fans Love'} />
      <h2 className="testimonial__title">
        What our customers say about us
      </h2>
      </Col>
      <Col lg='12'>
      <Testimonials />
      </Col>
    </Row>
  </Container>
</section> */}

      {/*=================Testimoials section ends================== */}
      <Newsletter />

    </>
  )
}

export default Home
